import validators from '../utils/validators';

class Note {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      patient: (v) => validators.isNotEmptyString(v),
      text: (v) => validators.isString(v),
      createdAt: (v) => validators.isValidDate(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid property ${property} in ${data.id}`);
      }

      this[property] = data[property];
    }
  }
}

export default Note;
